var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cost_main"},[_c('h3',{staticClass:"y_title",domProps:{"textContent":_vm._s(_vm.title)}}),_c('ul',{staticClass:"cost_list"},[_vm._l((_vm.list),function(item){return [_c('cost-item',{key:item.period,attrs:{"id":item.period,"title":_vm.title,"name":item.name,"status":item.status === 1}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }